var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_3688)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 22,
    r: 22,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0909 18.7734C31.9169 18.1686 31.6725 17.6341 31.3576 17.1701C31.0427 16.6978 30.6574 16.3001 30.2017 15.9769C29.7543 15.6455 29.2405 15.3928 28.6605 15.2188C28.0888 15.0447 27.4549 14.9577 26.7589 14.9577C25.458 14.9577 24.3145 15.2809 23.3285 15.9272C22.3507 16.5735 21.5884 17.514 21.0415 18.7486C20.4947 19.9749 20.2212 21.4747 20.2212 23.2479C20.2212 25.0211 20.4905 26.5291 21.0291 27.772C21.5677 29.0149 22.33 29.9637 23.3161 30.6183C24.3021 31.2646 25.4663 31.5877 26.8086 31.5877C28.0266 31.5877 29.0665 31.3723 29.9283 30.9414C30.7983 30.5022 31.4612 29.8849 31.9169 29.0895C32.3809 28.294 32.6129 27.3536 32.6129 26.2681L33.7067 26.4297H27.1442V22.3778H37.7958V25.5845C37.7958 27.8217 37.3235 29.7441 36.3789 31.3516C35.4343 32.9508 34.1334 34.1854 32.4762 35.0554C30.819 35.9171 28.9215 36.348 26.7837 36.348C24.3974 36.348 22.301 35.8219 20.4947 34.7695C18.6883 33.7089 17.2797 32.205 16.2688 30.2578C15.2662 28.3023 14.7649 25.9822 14.7649 23.2976C14.7649 21.2344 15.0632 19.3949 15.6598 17.7791C16.2647 16.1551 17.1098 14.7796 18.1953 13.6527C19.2808 12.5258 20.5444 11.6682 21.9862 11.0799C23.4279 10.4916 24.9898 10.1974 26.6719 10.1974C28.1136 10.1974 29.456 10.4087 30.6989 10.8313C31.9418 11.2456 33.0438 11.8339 34.005 12.5962C34.9744 13.3585 35.7657 14.2659 36.3789 15.3182C36.9921 16.3622 37.3857 17.514 37.5597 18.7734H32.0909Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_3688",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_3688"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_3688",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.d0c0525db562b896fe26fbe110d13fa0.svg";
export { ForwardRef as ReactComponent };